import React from 'react';
import About from '../components/About';
import Skills from '../components/Skills';
import Experience from '../components/Experience';
import Education from '../components/Education';
import { useScrollReveal } from '../hooks/useScrollReveal';

function AboutPage() {
  useScrollReveal();
  return (
    <main className="page">
      <About />
      <Experience />
      <Skills />
      <Education />
    </main>
  );
}

export default AboutPage;
